import { Copy, LayoutGrid, LogOut, Share2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BrandBand } from "@/components/vendor/Brand";

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
  toast.success("Link copied");
};

export const AdminHeader = ({ onLogout }) => {
  const url = `${window.location.origin}/vendor-pricing`;

  const share = async () => {
    if (!navigator.share) return copyText(url);
    try {
      await navigator.share({ title: "hausA Vendor Pricing Review", url });
    } catch (e) {
      if (e.name !== "AbortError") copyText(url);
    }
  };

  return (
    <>
      <BrandBand wide>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <span className="hx-band__meta">Admin</span>
          <Link to="/admin/studio" className="hx-btn hx-btn--light hx-btn--sm" data-testid="admin-studio-button">
            <LayoutGrid size={14} /> Studio
          </Link>
          <button className="hx-btn hx-btn--light hx-btn--sm" onClick={onLogout} data-testid="admin-logout-button">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </BrandBand>
      <div className="hx-sharebar">
        <div className="hx-container hx-container--wide hx-sharebar__inner">
          <span className="hx-sharebar__label">Public form</span>
          <span className="hx-sharebar__url" data-testid="admin-public-form-url">{url}</span>
          <button className="hx-btn hx-btn--ghost hx-btn--sm" onClick={() => copyText(url)} data-testid="admin-copy-link-button">
            <Copy size={14} /> Copy link
          </button>
          <button className="hx-btn hx-btn--sm" onClick={share} data-testid="admin-share-button">
            <Share2 size={14} /> Share
          </button>
        </div>
      </div>
    </>
  );
};
